<template>
  <li class="tree-item-li">
    <div
      class="tree-item-label"
      :class="{active: isActive}"
      @click="activeItem"
    >{{nodes.label}}</div>
    <ul v-if="isEnd" class="tree-item-ul">
      <tree-item
        v-for="(item, index) in nodes.nodes"
        :key="index"
        :nodes="item">
      </tree-item>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'treeItem',
  props: ['nodes'],
  data () {
    return {
    }
  },
  computed: {
    isEnd () {
      console.log(this.nodes.nodes)
      return this.nodes.nodes && this.nodes.nodes.length
    }
  },
  methods: {
    activeItem: () => {
    }
  }
}

</script>
